export enum EImageUsage {
  PaymentForm = 'payment-form',
  Profile = 'profile',
  Gallery = 'gallery',
  Discover = 'discover',
  Carousel = 'carousel',
  ImagePresets = 'imagePresets',
  Timeline = 'timeline',
  MessageMedia = 'messageMedia'
}
